import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { BLOG } from "@/lib/data";
import { Reveal, RevealStagger, StaggerItem, Cascade } from "@/components/Reveal";

export default function Blog() {
  return (
    <section id="blog" className="scroll-mt-24" data-testid="blog">
      <div className="container-shell">
        <Reveal className="max-w-2xl">
          <p className="overline">Blog</p>
          <h2 className="heading-lg mt-4">
            <Cascade text="Dijital dönüşüm {rehberiniz}." />
          </h2>
        </Reveal>

        <RevealStagger className="mt-[56px] grid grid-cols-1 gap-[32px] md:grid-cols-3">
          {BLOG.map((b) => (
            <StaggerItem key={b.slug}>
              <Link
                to={`/blog/${b.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-2xl border border-ink/5 bg-white shadow-[0_2px_10px_rgba(32,32,32,0.04)] transition-[transform,box-shadow] duration-500 hover:-translate-y-2 hover:shadow-[0_24px_50px_rgba(32,32,32,0.10)]"
                data-testid={`blog-card-${b.slug}`}
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    src={b.image}
                    alt={b.title}
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-orange px-3 py-1 text-xs font-bold text-white">
                    {b.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-7">
                  <p className="text-xs font-medium uppercase tracking-wider text-ink/40">
                    {b.date}
                  </p>
                  <h3 className="mt-3 text-lg font-bold leading-snug tracking-tight text-ink">
                    {b.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink/60">{b.excerpt}</p>
                  <span className="mt-auto pt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-ink transition-colors group-hover:text-orange">
                    Yazıyı Oku
                    <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </span>
                </div>
              </Link>
            </StaggerItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
}
